var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseBody",
    [
      _c(
        "BaseTopBar",
        [
          _c("BaseTopBarContent", { attrs: { className: "left" } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("sidebar.billinginvoice")) +
                " > " +
                _vm._s(_vm.data.code) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("BaseTopBarContent", { attrs: { className: "right" } }, [
            _c(
              "div",
              { staticClass: "action" },
              [
                _vm.data.status !== "paid"
                  ? _c(
                      "BaseButton",
                      {
                        attrs: { className: "btn-info" },
                        on: {
                          click: function($event) {
                            return _vm.onClickPay($event, _vm.data)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("apps.billing.button.payamount", {
                                number: _vm.getCurrencyWithNumber(
                                  _vm.numberel(_vm.data.total, "0,0.00")
                                )
                              })
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.data.status === "paid"
                  ? _c("div", { staticClass: "dropdown nodro item" }, [
                      _c("span", { staticClass: "text-success" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("apps.billing.status.paid")) +
                            "\n          "
                        )
                      ])
                    ])
                  : _vm._e()
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "BaseContent",
        { attrs: { loading: _vm.loading } },
        [
          _c("BillingInvoiceSummary", {
            attrs: { data: _vm.data, apps: _vm.apps }
          }),
          _vm._v(" "),
          _c("BillingInvoiceUsage", {
            attrs: {
              dateStart: _vm.dateStart,
              dateEnd: _vm.dateEnd,
              records: _vm.creditRecords,
              files: _vm.creditFiles,
              lineMessages: _vm.creditLineMessages,
              emails: _vm.creditEmails,
              qrcodes: _vm.creditQRCodes,
              branches: _vm.creditBranches,
              warehouses: _vm.creditWarehouses,
              users: _vm.creditUsers,
              apps: _vm.creditApps
            },
            model: {
              value: _vm.tabSelected,
              callback: function($$v) {
                _vm.tabSelected = $$v
              },
              expression: "tabSelected"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-291e147b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-291e147b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/billing/invoice/Single.vue
// module id = null
// module chunks = 